import { Col, Row, Space, Table } from "antd";
import React, { useEffect, useMemo } from "react";
import { CONFIG, KEY } from "../../constants/common.const";
import CommonFilterTable from "../../component/table/TableFiltter";
import moment from "moment";

function ListEquipment({ data = [], setCurrentNode = () => {}, currentNode,setFirstNodeFilter }) {
  
  const initColumns = [
    {
      title: "No",
      dataIndex: "No",
      width: 70,
      align: "center",
      type:"number",
      render: (_, __, index) => {
        return <span>{_}</span>;
      },
    },
    {
      title: "設備名称",
      dataIndex: "machineForSiteOfficeName",
      width: 100,
      align: "left",
    },
    {
      title: "管理番号",
      dataIndex: "machineForSiteOfficeCode",
      width: 100,
      align: "left",
    },
    {
      title: "世代番号",
      dataIndex: "generationNumber",
      width: 100,
      align: "center",
      type:"number"
    },
    {
      title: "設備分類",
      dataIndex: "machineClassificationMasterName",
      width: 200,
      align: "left",
    },
    {
      title: "設置場所",
      dataIndex: "installLocationName",
      align: "left",
      width: 200,
    },
    {
      title: "設置年月日",
      dataIndex: "applyDate",
      align: "center",
      width: 200,
    },
  ];

  const dataWithNo = useMemo(() => {
    return (data.data || []).map((item, index) => ({
      ...item,
      No: index + 1 + "",
      applyDate:item.applyDate ? moment(item.applyDate).format(KEY.DATE_DEFAULT) : ""
    }));
  }, [data]);
  return (
    <div>
      <CommonFilterTable
      setFirstNodeFilter={setFirstNodeFilter}
        color={"#fff"}
        className="table-selected-custom table-equipment-custome"
        onRow={(record) => {
          return {
            onClick: () => {
              setCurrentNode(record);
            },
          };
        }}
        rowKey={(record) => record.machineForSiteOfficeCode}
        rowClassName={(record) =>
          currentNode && record.machineForSiteOfficeCode === currentNode.machineForSiteOfficeCode
            ? "selected-row-facilityMaster"
            : ""
        }
        data={dataWithNo}
        columns={initColumns}
        scrollX={"max-content"}
        tableKey="equipment"
        addedLeft={150}
      />
    </div>
  );
}

export default ListEquipment;
